<template>
  <v-chart
    :force-fit="true" :height="height" :data="chartDatas"
    :padding="padding" :scale="scale"
  >
    <v-axis dataKey="axisX" :label="{textStyle: { fill: '#aaa' }}" />
    <v-axis dataKey="valA" :show="false" />
    <v-axis dataKey="valB" :show="false" />

    <v-tooltip />
    <v-legend />
    <v-facet 
      type="rect" :show-title="false" 
      :fields="[null, 'type']" :views="chartFacetViews"
      :padding="[0, 0, 20, 0]"
    />
  </v-chart>
</template>

<script>
export default {
  name: 'TrafficsChart',
  components: {},
  props: {
    height: { type: Number, default: 350 },
    padding: { type: Array, default: () => [10, 10, 10, 10] },
    scale: { type: Array, default: () => null },
    datas: { type: Array, default: () => [] }
    
  },
  data () {
    return {
      chartDatas: []
    }
  },
  computed: {},
  watch: {
    datas: function(datas) {
      if (datas.length) this.$nextTick(this.createTrafficsChartDatas)
    }
  },
  created() {
    this.createTrafficsChartDatas()
  },
  methods: {
    createTrafficsChartDatas() {
      const chartDatas = []
      this.datas.forEach(data => {
        let { axisX, direct, total, success, rate } = data
        let dot = total - direct
        chartDatas.push(
          { axisX, name: '访问节点', valA: dot, type: 'a' },
          { axisX, name: '访问直读', valA: direct, type: 'a' },
          { axisX, name: '访问总量', valB: total, type: 'b' },
          { axisX, name: '成功次数', valB: success, type: 'b', rate }
        )
      })
      this.chartDatas = chartDatas
    },
    
    chartFacetViews(view, facet) {
      const { rowValue, data } = facet
      const series = []

      switch (rowValue) {
        case 'a':
          series.push({
            quickType: 'stackBar',
            position: 'axisX*valA',
            color: ['name', ['#1890ff', '#5ECB77']]
          })
          break
        case 'b':
          series.push({
            quickType: 'smoothArea',
            position: 'axisX*valB',
            color: ['name', ['#d8d8ff', '#6060ff']],
            tooltip: ['name*valA*valB*rate', this.trafficTooltipFun]
          })
          break
        default: break
      }

      return { data, series }
    },
    trafficTooltipFun(name, valA, valB, rate) {
      let value = valA || valB
      if (rate) value += ` (${Math.floor(rate * 100)}%)`
      return { name, value }
    }
  }
}
</script>

<style lang="less" scoped>
  .spin-loading{
    background: rgba(255, 255, 255, 0.5);
    position: absolute;
    width: 100%;  
    height: 100%;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
